
export default function ContactHero() {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat animated-sky-bg"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/853fd0874fb6bc04f73dcc077adf98ab.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-blue-900/40 floating-overlay"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            お問い合わせ
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            リノベーション、メンテナンス、コンサルティングに関するご相談は、
            お気軽にお問い合わせください。無料見積りも承っております。
          </p>
        </div>
      </div>
      
      {/* Twinkling stars effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-1 h-1 bg-white rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-blue-200 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-1/3 right-1/4 w-1 h-1 bg-blue-300 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
        <div className="absolute top-1/2 left-1/5 w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '1.5s' }}></div>
        <div className="absolute top-3/4 right-1/5 w-1 h-1 bg-blue-200 rounded-full animate-pulse" style={{ animationDelay: '3s' }}></div>
      </div>
    </section>
  );
}
